import { Flex, type FlexProps, type SpaceProps } from "@chakra-ui/react";
import React, { type PropsWithChildren } from "react";

/**
 * A single-column layout with standardized gap sizing. Used for grouping several diptychs together.
 */
export function DiptychColumn({
  gap = "huge",
  children,
  ...spaceProps
}: PropsWithChildren<SpaceProps & Pick<FlexProps, "gap">>) {
  return (
    <Flex flexDir="column" gap={gap} {...spaceProps}>
      {children}
    </Flex>
  );
}
